import { z } from 'zod'
import { t } from 'i18next'
import {
  KmSchema,
  SignalSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
const DEFAULT_ZUGMELDESTELLE = {
  art: '' as '' | Betriebsstellenart,
  name: ''
}

const DEFAULT_AUFTRAG_24_11 = {
  enabled: false
}

const DEFAULT_AUFTRAG_24_12 = {
  enabled: false
}

const DEFAULT_AUFTRAG_24_11_12_FIELDS = {
  feld_24_16_signal: '',
  feld_24_15_km: '',
  feld24_13: DEFAULT_ZUGMELDESTELLE,
  feld24_14: DEFAULT_ZUGMELDESTELLE,
  feld_24_15_16_type: '' as const
}

const DEFAULT_AUFTRAG_24_20 = {
  enabled: false
}

const DEFAULT_AUFTRAG_24_30 = {
  enabled: false
}

const DEFAULT_BEFEHL_24_FORM = {
  auftrag_24_11: DEFAULT_AUFTRAG_24_11,
  auftrag_24_12: DEFAULT_AUFTRAG_24_12,
  auftrag_24_11_12_fields: DEFAULT_AUFTRAG_24_11_12_FIELDS,
  auftrag_24_20: DEFAULT_AUFTRAG_24_20,
  auftrag_24_30: DEFAULT_AUFTRAG_24_30
}

// Schema definitions
const Auftrag24_11Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_24_11.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_24_11))

const Auftrag24_12Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_24_12.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_24_12))

const Auftrag24_11_12_FieldsSchema = z
  .object({
    feld_24_16_signal: SignalSchema,
    feld_24_15_km: KmSchema,
    feld24_13: ZugmeldestelleSchema,
    feld24_14: ZugmeldestelleSchema,
    feld_24_15_16_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_24_11_12_FIELDS.feld_24_15_16_type)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_24_11_12_FIELDS))

const Auftrag24_20Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_24_20.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_24_20))

const Auftrag24_30Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_24_30.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_24_30))

// Base schema
const Befehl24FormSchemaBase = z
  .object({
    auftrag_24_11: Auftrag24_11Schema,
    auftrag_24_12: Auftrag24_12Schema,
    auftrag_24_11_12_fields: Auftrag24_11_12_FieldsSchema,
    auftrag_24_20: Auftrag24_20Schema,
    auftrag_24_30: Auftrag24_30Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_24_FORM))

export const Befehl24FormSchema = Befehl24FormSchemaBase

// Validation schema
export const createBefehl24FormValidationSchema = () =>
  Befehl24FormSchema.refine(
    (data) => {
      return (
        !(data.auftrag_24_11.enabled && data.auftrag_24_12.enabled) &&
        !(data.auftrag_24_20.enabled && data.auftrag_24_30.enabled) &&
        (data.auftrag_24_11.enabled || data.auftrag_24_12.enabled)
      )
    },
    {
      message: t('ui-validation:befehl24.select_one')
    }
  )

export type Befehl24FormData = z.infer<typeof Befehl24FormSchemaBase>
